export default __webpack_public_path__ + "static/2-9bab039133232a880231bb710c151788.svg";